import React, { useState } from 'react';
import { PRODUCT_VIDEO_URL } from '../../data/links';
type ProductVideoProps = {
  label: string;
  fallback: React.ReactNode;
};
export function ProductVideo({
  label,
  fallback
}: ProductVideoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) return <>{fallback}</>;
  return <video src={PRODUCT_VIDEO_URL} autoPlay muted loop playsInline preload="metadata" aria-label={label} onError={() => setFailed(true)} className="block aspect-[16/10] w-full bg-surface object-cover object-top" data-id="element-93" data-mp="2yme1t3z3b2sn" />;
}